export default "__VITE_ASSET__CJV0oX8K__"